<template>
  <b-overlay
    :show="mostrarLoader"
    opacity="0.50"
    rounded="sm"
    spinner-variant="primary"
    spinner-type="grow"
  >
    <b-card>
      <b-row class="mt-1">
        <b-col cols="12">
          <b-form-group>
            <label class="text-sm"><span class="text-danger">*</span> Nombre</label>
            <b-input :danger="errors.has('nombre')" label="Nombre" v-model="rol.nombre" v-validate="'required|max:40'" name="nombre" class="w-full required" placeholder="Ingrese el nombre" maxlength="40" :class="[{'is-invalid': errors.has('nombre')}]"/>
            <span class="text-danger text-sm" v-show="errors.has('nombre')">{{  errors.first('nombre') }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <label class="text-sm"><span class="text-danger">*</span> Descripción</label>
          <b-input :danger="errors.has('descripcion')" label="Descripción" v-model="rol.descripcion" v-validate="'required|max:100'" name="descripcion" class="w-full required" placeholder="Ingrese una descripción..." maxlength="100" data-vv-as="descripción" :class="[{'is-invalid': errors.has('descripcion')}]"/>
          <span class="text-danger text-sm" v-show="errors.has('descripcion')">{{  errors.first('descripcion') }}</span>
        </b-col>
      </b-row>
      <b-button v-if="estaEnModoEdicion" variant="primary" :disabled="bloqueo_boton" id="button-with-loading" type="filled" class="mt-1 mr-2" v-on:click="submitFormRol">Guardar</b-button>
      <b-button v-if="estaEnModoEdicion" variant="primary" :disabled="bloqueo_boton" id="button-with-loading" type="filled" class="mt-1" v-on:click="goToAsignarPermisos"><font-awesome-icon icon="cog"/> Asignar permisos</b-button>
      <b-button v-else :disabled="bloqueo_boton" id="button-with-loading" variant="primary" type="filled" class="mt-1 vs-con-loading__container" v-on:click="submitFormRol">Registrar</b-button>
    </b-card>
  </b-overlay>
</template>

<script>
import axios from '@/axios';

import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
import ToastificationContent from "@core/components/toastification/ToastificationContent";
Validator.localize("es", es);

export default {
    data() {
        return {
            rol: {
                nombre: '',
                descripcion: '',
            },
            submitted: false,
            bloqueo_boton: false,
            input_prop: {
                // codigo:           {danger: false, dangertext: ''},
                nombre:           {danger: false, dangertext: ''},
                descripcion:      {danger: false, dangertext: ''},
            },
          mostrarLoader: false,
        }
    },
    methods: {
        submitFormRol(){
            this.openLoadingInDiv()
            this.$validator.validateAll().then(result => {
                if (result) {
                  // if form have no errors
                  if (this.estaEnModoEdicion){
                    this.update()
                  }
                  else{
                    this.create()
                  }
                } else {
                  this.closeLoadingInDiv();
                }
            });
        },

        create: function (e) {
            this.openLoadingInDiv()
            axios
                .post('api/rol/',
                    this.rol
                ).then(response => {
                    this.closeLoadingInDiv()
                    if(response === undefined){}else{
                        this.$router.push({name: 'rolEditar', params: { token_publico: response.data.token_publico }})
                    }
                }).catch(error => {
                    if (400 == error.response.status){
                        var errores=error.response.data;
                        this.$handle400(errores);
                    }else{
                        this.$errores_no_controlados(error);
                    }
                    this.closeLoadingInDiv();
                });
        },
        openLoadingInDiv(){
            this.bloqueo_boton = true
            this.mostrarLoader = true
        },
        closeLoadingInDiv(){
            this.mostrarLoader = false
            this.bloqueo_boton = false
        },
        showToast() {
          this.$toast.success({
            component: ToastificationContent,
            props: {
              title: 'Rol',
              icon: 'SaveIcon',
              text: 'Cambios Guardados correctamente',
            },
          },
          {
            position: 'bottom-right',
          })
        },
        update: function (e) {
          this.openLoadingInDiv()
               axios.put(`api/rol/${this.$route.params.token_publico}/`,
                  this.rol
              ).then(response => {
                  //this.$router.push('/usuario/rol/consultar');
                  this.cleanErrors();
                  this.showToast()
                  this.closeLoadingInDiv()
              })
              .catch(error => {
                  this.cleanErrors();
                  var errores=error.response.data;
                  for(error in errores){
                      this.input_prop[error].danger = true;
                      this.input_prop[error].dangertext = errores[error][0];
                  }
                  this.closeLoadingInDiv()
              });
        },
        cleanErrors(){
            for (var key in this.input_prop) {
                this.input_prop[key].danger = false;
            }
        },
        goToAsignarPermisos(){
            this.$router.push({name: 'rolPermiso', params: {token_publico: this.$route.params.token_publico }});
        },
    },
    mounted() {
      if(this.estaEnModoEdicion){
        this.openLoadingInDiv()
        axios.get(`api/rol/${this.$route.params.token_publico}`)
          .then( response => {
              this.rol = response.data
              this.closeLoadingInDiv()
          });
      }
    },
    computed: {
      estaEnModoEdicion(){
        if (this.$route.params.token_publico){
          return true
        }
        else{
          return false
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
          if(from.name==="rolRegistrar"){
            vm.showToast();
          }
          else{
            vm.rol = {
              nombre: '',
              descripcion: '',
            }
          }
      });
    },
}
</script>

<style>
  .required > .vs-input--label::before{
      content: "* ";
      color: #F56C6C;
  }
</style>
